export default [
  {
    name: "IsValid",
    title: 'Status',
    width: "350px",
    sortField: "IsValid",
    formatter(value) {
      if (value == "true") {
        return '<i class="fa-solid fa-circle-check green-font"></i>';
      } else {
        return '<i class="fas fa-exclamation-triangle red-font"></i>';
      }
    }
  },
  {
    name: "ClaimName",
    title: 'Claim Name',
    width: "350px",
    sortField: "ClaimName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "FiscalYear",
    title: 'Fiscal Year',
    width: "350px",
    sortField: "FiscalYear",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "FiscalMonth",
    title: 'Fiscal Month',
    width: "350px",
    sortField: "FiscalMonth",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "ClaimStatus",
    title: 'Claim Status',
    width: "350px",
    sortField: "ClaimStatus",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "Analyst",
    title: 'Analyst',
    width: "350px",
    sortField: "Analyst",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "ErrorMsg",
    title: 'Error Message',
    width: "350px",
    sortField: "ErrorMsg"
  }


]